// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
export type CharitableTrustDesignerIllustrationData_CrtProposalYearlyProjectionFragment = { __typename?: 'CRTProposalYearlyProjection', year: number, beginningOfYear: CurrencyUSD, remainderValue: CurrencyUSD, payout: CurrencyUSD, taxed: CurrencyUSD, growth: CurrencyUSD, cumulativeTaxed: CurrencyUSD, cumulativeIncome: CurrencyUSD };

export type CharitableTrustDesignerIllustrationData_CrtProposalProjectionFragment = { __typename?: 'CRTProposalProjection', projectedCharitableRemainder: CurrencyUSD, charitableRemainder: CurrencyUSD, personalPortfolio: CurrencyUSD, personalBenefit: CurrencyUSD, capitalGainsDeferred: CurrencyUSD, capitalGainsTaxDeferred: CurrencyUSD, ordinaryIncomeTaxSaved: CurrencyUSD, metCharitableThreshold: boolean, yearly: Array<(
    { __typename?: 'CRTProposalYearlyProjection' }
    & CharitableTrustDesignerIllustrationData_CrtProposalYearlyProjectionFragment
  )> };

export type CharitableTrustDesignerIllustrationData_CltProposalYearlyProjectionFragment = { __typename?: 'CLTProposalYearlyProjection', year: number, beginningOfYear: CurrencyUSD, remainderValue: CurrencyUSD, payout: CurrencyUSD, taxed: CurrencyUSD, growth: CurrencyUSD, cumulativeTaxed: CurrencyUSD, cumulativeCharity: CurrencyUSD };

export type CharitableTrustDesignerIllustrationData_CltProposalProjectionFragment = { __typename?: 'CLTProposalProjection', projectedCharitableBenefit: CurrencyUSD, personalRemainder: CurrencyUSD, personalBenefit: CurrencyUSD, capitalGainsDeferred: CurrencyUSD, capitalGainsTaxDeferred: CurrencyUSD, estateTaxSaved: CurrencyUSD, ordinaryIncomeTaxSaved: CurrencyUSD, taxableGift: CurrencyUSD, yearly: Array<(
    { __typename?: 'CLTProposalYearlyProjection' }
    & CharitableTrustDesignerIllustrationData_CltProposalYearlyProjectionFragment
  )> };

export type CharitableTrustDesignerIllustrationData_NoPlanProjectionYearlyFragment = { __typename?: 'NoPlanProjectionYearly', endOfYear: CurrencyUSD, year: number };

export type CharitableTrustDesignerIllustrationData_NoPlanProjectionFragment = { __typename?: 'NoPlanProjection', projectedValue: CurrencyUSD, yearly: Array<(
    { __typename?: 'NoPlanProjectionYearly' }
    & CharitableTrustDesignerIllustrationData_NoPlanProjectionYearlyFragment
  )> };

export type CharitableTrustDesignerIllustrationData_CltProposalFragment = { __typename?: 'CLTProposal', id: string, projectionLow: (
    { __typename?: 'CLTProposalProjection' }
    & CharitableTrustDesignerIllustrationData_CltProposalProjectionFragment
  ), projectionMedium: (
    { __typename?: 'CLTProposalProjection' }
    & CharitableTrustDesignerIllustrationData_CltProposalProjectionFragment
  ), projectionHigh: (
    { __typename?: 'CLTProposalProjection' }
    & CharitableTrustDesignerIllustrationData_CltProposalProjectionFragment
  ), noPlanProjectionLow: (
    { __typename?: 'NoPlanProjection' }
    & CharitableTrustDesignerIllustrationData_NoPlanProjectionFragment
  ), noPlanProjectionMedium: (
    { __typename?: 'NoPlanProjection' }
    & CharitableTrustDesignerIllustrationData_NoPlanProjectionFragment
  ), noPlanProjectionHigh: (
    { __typename?: 'NoPlanProjection' }
    & CharitableTrustDesignerIllustrationData_NoPlanProjectionFragment
  ) };

export type CharitableTrustDesignerIllustrationData_CrtProposalFragment = { __typename?: 'CRTProposal', id: string, projectionLow: (
    { __typename?: 'CRTProposalProjection' }
    & CharitableTrustDesignerIllustrationData_CrtProposalProjectionFragment
  ), projectionMedium: (
    { __typename?: 'CRTProposalProjection' }
    & CharitableTrustDesignerIllustrationData_CrtProposalProjectionFragment
  ), projectionHigh: (
    { __typename?: 'CRTProposalProjection' }
    & CharitableTrustDesignerIllustrationData_CrtProposalProjectionFragment
  ), noPlanProjectionLow: (
    { __typename?: 'NoPlanProjection' }
    & CharitableTrustDesignerIllustrationData_NoPlanProjectionFragment
  ), noPlanProjectionMedium: (
    { __typename?: 'NoPlanProjection' }
    & CharitableTrustDesignerIllustrationData_NoPlanProjectionFragment
  ), noPlanProjectionHigh: (
    { __typename?: 'NoPlanProjection' }
    & CharitableTrustDesignerIllustrationData_NoPlanProjectionFragment
  ) };

export const Operations = {
  Fragment: {
    CharitableTrustDesignerIllustrationData_CRTProposalYearlyProjection: 'CharitableTrustDesignerIllustrationData_CRTProposalYearlyProjection' as const,
    CharitableTrustDesignerIllustrationData_CRTProposalProjection: 'CharitableTrustDesignerIllustrationData_CRTProposalProjection' as const,
    CharitableTrustDesignerIllustrationData_CLTProposalYearlyProjection: 'CharitableTrustDesignerIllustrationData_CLTProposalYearlyProjection' as const,
    CharitableTrustDesignerIllustrationData_CLTProposalProjection: 'CharitableTrustDesignerIllustrationData_CLTProposalProjection' as const,
    CharitableTrustDesignerIllustrationData_NoPlanProjectionYearly: 'CharitableTrustDesignerIllustrationData_NoPlanProjectionYearly' as const,
    CharitableTrustDesignerIllustrationData_NoPlanProjection: 'CharitableTrustDesignerIllustrationData_NoPlanProjection' as const,
    CharitableTrustDesignerIllustrationData_CLTProposal: 'CharitableTrustDesignerIllustrationData_CLTProposal' as const,
    CharitableTrustDesignerIllustrationData_CRTProposal: 'CharitableTrustDesignerIllustrationData_CRTProposal' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const CharitableTrustDesignerIllustrationData_CltProposalYearlyProjectionFragmentDoc = gql`
    fragment CharitableTrustDesignerIllustrationData_CLTProposalYearlyProjection on CLTProposalYearlyProjection {
  year
  beginningOfYear
  remainderValue
  payout
  taxed
  growth
  cumulativeTaxed
  cumulativeCharity
}
    `;
export const CharitableTrustDesignerIllustrationData_CltProposalProjectionFragmentDoc = gql`
    fragment CharitableTrustDesignerIllustrationData_CLTProposalProjection on CLTProposalProjection {
  projectedCharitableBenefit
  personalRemainder
  personalBenefit
  capitalGainsDeferred
  capitalGainsTaxDeferred
  estateTaxSaved
  ordinaryIncomeTaxSaved
  taxableGift
  yearly {
    ...CharitableTrustDesignerIllustrationData_CLTProposalYearlyProjection
  }
}
    ${CharitableTrustDesignerIllustrationData_CltProposalYearlyProjectionFragmentDoc}`;
export const CharitableTrustDesignerIllustrationData_NoPlanProjectionYearlyFragmentDoc = gql`
    fragment CharitableTrustDesignerIllustrationData_NoPlanProjectionYearly on NoPlanProjectionYearly {
  endOfYear
  year
}
    `;
export const CharitableTrustDesignerIllustrationData_NoPlanProjectionFragmentDoc = gql`
    fragment CharitableTrustDesignerIllustrationData_NoPlanProjection on NoPlanProjection {
  projectedValue
  yearly {
    ...CharitableTrustDesignerIllustrationData_NoPlanProjectionYearly
  }
}
    ${CharitableTrustDesignerIllustrationData_NoPlanProjectionYearlyFragmentDoc}`;
export const CharitableTrustDesignerIllustrationData_CltProposalFragmentDoc = gql`
    fragment CharitableTrustDesignerIllustrationData_CLTProposal on CLTProposal {
  id
  projectionLow {
    ...CharitableTrustDesignerIllustrationData_CLTProposalProjection
  }
  projectionMedium {
    ...CharitableTrustDesignerIllustrationData_CLTProposalProjection
  }
  projectionHigh {
    ...CharitableTrustDesignerIllustrationData_CLTProposalProjection
  }
  noPlanProjectionLow {
    ...CharitableTrustDesignerIllustrationData_NoPlanProjection
  }
  noPlanProjectionMedium {
    ...CharitableTrustDesignerIllustrationData_NoPlanProjection
  }
  noPlanProjectionHigh {
    ...CharitableTrustDesignerIllustrationData_NoPlanProjection
  }
}
    ${CharitableTrustDesignerIllustrationData_CltProposalProjectionFragmentDoc}
${CharitableTrustDesignerIllustrationData_NoPlanProjectionFragmentDoc}`;
export const CharitableTrustDesignerIllustrationData_CrtProposalYearlyProjectionFragmentDoc = gql`
    fragment CharitableTrustDesignerIllustrationData_CRTProposalYearlyProjection on CRTProposalYearlyProjection {
  year
  beginningOfYear
  remainderValue
  payout
  taxed
  growth
  cumulativeTaxed
  cumulativeIncome
}
    `;
export const CharitableTrustDesignerIllustrationData_CrtProposalProjectionFragmentDoc = gql`
    fragment CharitableTrustDesignerIllustrationData_CRTProposalProjection on CRTProposalProjection {
  projectedCharitableRemainder
  charitableRemainder
  personalPortfolio
  personalBenefit
  capitalGainsDeferred
  capitalGainsTaxDeferred
  ordinaryIncomeTaxSaved
  metCharitableThreshold
  yearly {
    ...CharitableTrustDesignerIllustrationData_CRTProposalYearlyProjection
  }
}
    ${CharitableTrustDesignerIllustrationData_CrtProposalYearlyProjectionFragmentDoc}`;
export const CharitableTrustDesignerIllustrationData_CrtProposalFragmentDoc = gql`
    fragment CharitableTrustDesignerIllustrationData_CRTProposal on CRTProposal {
  id
  projectionLow {
    ...CharitableTrustDesignerIllustrationData_CRTProposalProjection
  }
  projectionMedium {
    ...CharitableTrustDesignerIllustrationData_CRTProposalProjection
  }
  projectionHigh {
    ...CharitableTrustDesignerIllustrationData_CRTProposalProjection
  }
  noPlanProjectionLow {
    ...CharitableTrustDesignerIllustrationData_NoPlanProjection
  }
  noPlanProjectionMedium {
    ...CharitableTrustDesignerIllustrationData_NoPlanProjection
  }
  noPlanProjectionHigh {
    ...CharitableTrustDesignerIllustrationData_NoPlanProjection
  }
}
    ${CharitableTrustDesignerIllustrationData_CrtProposalProjectionFragmentDoc}
${CharitableTrustDesignerIllustrationData_NoPlanProjectionFragmentDoc}`;